const homeCN = {
    HOME_01:'首页',
    HOME_02:'邮箱注册，',
    HOME_03:'完成登录，可享受以下功能 ——',
    HOME_04:'扩大公司联系人搜索结果翻页限制',
    HOME_05:'更加详细精确公司联系人数据',
    HOME_06:'联系人查看功能开放',
    HOME_07:'确认退出登录吗?',
    HOME_08:'退出登录',
    HOME_10:'请选择',
    HOME_11:'加入收藏夹失败，请使用Ctrl+D进行添加，或手动在浏览器里进行设置.',
    HOME_12:'购买套餐',
    HOME_13:'取消',
    HOME_14:'确定',
    TITLE_FIND:'套餐介绍',
    VISITOR:'游客',
    MON:'每月',
    CPY_SEARCH:'公司搜索',
    CTT_SEARCH:'联系人搜索',
    CPY_DETAIL:'公司详情',
    CTT_DETAIL:'联系人邮箱查看',
    API_PARTNER:'应用接口合作伙伴',
    FREE_PLAN:'免费版',
    PRO_PLAN:'专业版',
    ENTERPRISE_PLAN:'企业版',
    PRICING:'价格',
    SEARCH_PER:'搜索额度',
    PRICE_COMPARE:'套餐比较',
    USED_NOW:'正在使用',
    CHECK_CONTACT:'联系人每日额度',
    EXPORT_OPTION:'导出',
    MY_CONTACT:'我的联系人',
    MY_COMPANY:'我的公司',
    HIGH_CONTACT_SEARCH:'高级联系人搜索',
    HIGH_COMPANY_SEARCH:'高级公司搜索',
    PURCHASE:'购买',
    PER_SEARCH_COMPANY:'公司搜索每日额度',
    PER_SEARCH_CONTACT:'联系人搜索每日额度',
    PER_DETAIL_COMPANY:'公司详情查看每日额度',
    CONTACT_CHECK:'联系人邮箱查看每日额度',
    EXPORT_TO_EMAIL:'导出数据到邮箱',
    EXPORT_TO_CSV:'导出数据到CSV格式文件',
    LOGIN_REG:'登录/注册',
    UPGRADE_SUCCESS:'升级成功',
    UPGRADE_WRONG:'升级失败',
    SURE_PURCHASE:'是否使用账户金额，为套餐付款？',
    LOG_OUT:'退出登录',
    UP_LEVEL_TIPS:'使用账户金额，为升级套餐付款。',
    PAY_MEAL_DEFICIENCY:'账户余额不足，现在充值购买套餐。',
    CHARGE_FOR_BALANCE:'暂不购买套餐，使用账户余额付费',

    SEARCH_CMP:'搜公司',
    SEARCH_CCT:'搜联系人',
    MY_COMPANY_AND_PERSON: '我的收藏'
}
export default homeCN


// WEBPACK FOOTER //
// ./src/lan/cn/cn_home.js